<template>
  <div class="overlay">
    <sm-loading-indicator
      class="loading"
      v-if="loading"
    />
    <template v-else>
      <icon :class="{ play }" icon="play" />
      <label aria-hidden="true" v-if="play">{{ $t('MORE_CONTENT_PLAY_CTA') }}</label>
    </template>
  </div>
</template>

<script>
import { generateCacheKey } from '~/helpers'

export default {
  name: 'video-overlay',
  serverCacheKey: generateCacheKey,
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    play: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>

.overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 0;
  border: 0;
  background-color: rgba($color-black, 0.4);
  will-change: auto;

  .loading {
    height: 60px;
    width: 60px;
  }

  .icon {
    height: 48px;
    width: 48px;

    &.play {
      height: 60px;
      width: 60px;
      margin: $d-tiny;
    }
  }

  label {
    @include font('070');
    @include f-color-white;
    @include label-serif-lrg;

    text-align: center;
  }
}
</style>
